module.exports = __webpack_public_path__ + "img/luna gibosa menguante.65efa00f.svg";